import React from 'react'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      className="design-iconfont"
    >
      <g fill="none" fill-rule="evenodd">
        <path fill="#276EE8" d="M0 0H60V60H0z" />
        <path
          d="M24.0000001,20.7999998 C26.121732,20.7999998 28.1565632,21.6428545 29.6568543,23.1431455 C31.1571453,24.6434365 32.0000001,26.6782678 32.0000001,28.7999998 L32.0000001,31.9999997 L1.38711634e-07,31.9999997 L1.38711634e-07,28.7999998 C-0.000803242343,24.4410178 3.48822172,20.8836922 7.84640023,20.7999998 C10.0611465,22.8604279 12.9750292,24.004024 16.0000001,23.9999998 C19.0241386,24.0043711 21.937599,22.8626559 24.1536,20.8047998 L24.0000001,20.7999998 Z M16.0000001,0 C21.7437615,0 26.4,4.65623856 26.4,10.3999999 C26.4,16.1437613 21.7437615,20.7999998 16.0000001,20.7999998 C10.2562388,20.7999998 5.60000023,16.1437613 5.60000023,10.3999999 C5.60000023,4.65623856 10.2562388,0 16.0000001,0 L16.0000001,0 Z"
          transform="translate(14 14)"
          fill="#FFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  )
}

const DefaultAvatarIcon = (props) => {
  const { width = 20, height = 20 } = props
  return <Icon width={width} height={height} />
}

export default DefaultAvatarIcon
